import { type RefObject, useEffect, useState } from "react";

function useScrollAnimation(
  target: RefObject<Element | null> | string,
  resetKey?: unknown,
): boolean {
  const [prevResetKey, setPrevResetKey] = useState(resetKey);
  const [scrolledPast, setScrolledPast] = useState(false);

  if (prevResetKey !== resetKey) {
    setPrevResetKey(resetKey);
    setScrolledPast(false);
  }

  useEffect(() => {
    const el =
      typeof target === "string"
        ? document.getElementById(target)
        : target.current;

    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setScrolledPast(
          !entry.isIntersecting && entry.boundingClientRect.top < 0,
        );
      },
      { threshold: 0 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [target, resetKey]);

  return scrolledPast;
}

export default useScrollAnimation;
